import React from 'react';
export function Footer() {
  return <footer className="bg-[#10284D] px-4 py-12 text-center text-sm text-white/60" data-id="element-69" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-70" data-mp="3gg0yw2enzvx4">
        <div className="mb-3 font-serif text-xl font-bold text-white" data-id="element-71" data-mp="3gh3n22klrk9c">
          🦜 SPANISH READY
        </div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/50" data-id="element-72" data-mp="36p6dt1d5n2d9">
          The complete Spanish curriculum for teachers, homeschoolers, and
          families worldwide.
        </p>
        <nav aria-label="Legal" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-73" data-mp="38qz78i6g9vx">
          <a href="#terms" className="transition-colors duration-200 ease-out hover:text-white" data-id="element-74" data-mp="3ldan5eqbi1jd">
            Terms &amp; Conditions
          </a>
          <a href="#privacy" className="transition-colors duration-200 ease-out hover:text-white" data-id="element-75" data-mp="3qf9qwppyz0gu">
            Privacy Policy
          </a>
          <a href="#contact" className="transition-colors duration-200 ease-out hover:text-white" data-id="element-76" data-mp="2eyjs3rnvlax9">
            Contact
          </a>
        </nav>
        <p data-id="element-77" data-mp="3l9sfwwylmeks">© 2026 Spanish Ready — All rights reserved.</p>
      </div>
    </footer>;
}